import { belongsTo } from '@ember-data/model';
import { service } from '@ember/service';
import Super from './document-request';

export default class DocumentRequestCreditCardInfo extends Super {
  @service intl;

  documentIcon = 'credit-card';
  mixpanelType = 'Credit card form';

  @belongsTo('card', { async: false, inverse: null }) card;

  get displayTitle() {
    return this.intl.t('site.documents.creditCardForm.title');
  }
}
